// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { PaymentPlanActionTypeDTO } from './payment-plan-action-type-dto';

/**
 * 
 * @export
 * @interface PaymentPlanActionDTO
 */
export interface PaymentPlanActionDTO {
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanActionDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanActionDTO
     */
    typeId: PaymentPlanActionDTOTypeIdEnum;
    /**
     * 
     * @type {PaymentPlanActionTypeDTO}
     * @memberof PaymentPlanActionDTO
     */
    type: PaymentPlanActionTypeDTO;
    /**
     * 
     * @type {Date}
     * @memberof PaymentPlanActionDTO
     */
    completedAt?: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentPlanActionDTOTypeIdEnum {
    CONFIRM = 'CONFIRM',
    ADDRESS = 'ADDRESS',
    CARDDETAILS = 'CARD_DETAILS'
}



